'use client';

import { ReactElement, cloneElement, FC } from 'react';
import { ButtonComponentProps } from '../../types';
import { RoleCheckActionType } from './utils';
import { useUserAccessControl } from './userAccessControl';

interface UserAccessWithRoleCheckProps {
  children: ReactElement<ButtonComponentProps>;
  actionType?: RoleCheckActionType;
}

export const UserAccessWithRoleCheck: FC<UserAccessWithRoleCheckProps> = ({
  children,
  actionType = RoleCheckActionType.TRADE, // Default fallback
}) => {
  const { shouldInterceptAction, interceptAction } = useUserAccessControl();

  const needsInterception = shouldInterceptAction(actionType);

  if (needsInterception) {
    return cloneElement(children, {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onClick: interceptAction(actionType, () => {}),
    });
  }

  return children;
};
